import React from 'react';
import type { PlayerAddressProps } from '../../types';
import { Button, Text, View } from '../../Components/Themed';

type ShippingSummaryCardProps = {
    onChangeAddress: () => void,
    player_address?:PlayerAddressProps
}

const ShippingSummaryCard = ({ player_address, onChangeAddress }:ShippingSummaryCardProps) => {

    return (
        <View>
            <View style={{ padding:5, flexDirection:'row', alignItems:'center' }}>
                <Text style={{ flex:1 }} size={14} theme='h1'>Shipping Address</Text>
                <Button
                    title={player_address ? 'Change' : 'Select Address'}
                    type='text'
                    onPress={() => onChangeAddress()}
                />
            </View>
            {player_address ?
            <View style={{ padding:5, marginTop:10 }}>
                <Text size={12} theme='description'>{player_address.street}</Text>
                <Text style={{ marginTop:3 }} size={12} theme='description'>{player_address.city}, {player_address.state} {player_address.zip}</Text>
            </View>
            :<></>}
        </View>
    )
}

export default ShippingSummaryCard